import { useState } from 'react';

import { useDisconnect } from '@reown/appkit/react';
import { LogOut } from 'lucide-react';

import { useAuth } from '@/lib/hooks/useAuth';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export const Logout = ({ children }) => {
  const { signOut, isSingOutPending } = useAuth();

  const { disconnect } = useDisconnect();

  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut();
      await disconnect();
      setLogoutModalOpen(false);
      console.log('User logged out successfully');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <Dialog open={logoutModalOpen} onOpenChange={setLogoutModalOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-sm flex flex-col items-center text-center">
        {/* <DialogTitle className='hidden' /> */}
        <div className="p-2 rounded-full bg-secondary/50 w-32 h-32 flex items-center text-primary justify-center">
          <LogOut size={60} />
        </div>
        <div>
          <DialogTitle className="text-xl">Log out</DialogTitle>
          <DialogDescription className="text-md">
            Are you sure you want to log out?
          </DialogDescription>
        </div>
        <div className="flex gap-4 justify-end">
          <DialogClose asChild>
            <Button
              type="button"
              variant="outline"
              data-testid="logout-dialog-cancel-button"
            >
              Cancel
            </Button>
          </DialogClose>

          <Button
            variant="destructive"
            onClick={handleLogout}
            loading={isSingOutPending}
            data-testid="logout-dialog-logout-button"
          >
            Log out
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
